import {IActivityThemeImageDraw} from "@/model/activity";
import {CardPreview} from "@/model/materials/card_preview";

export interface ICard {
    card_id: string;
    internal_name: string;
    header_image_url: string;
    margin: number[];
    draws: IActivityThemeImageDraw[]
    footer_image_url: string;
}

export class Cards {
    readonly cards: CardPreview[]

    constructor(public readonly data: { [key: string]: ICard }) {
        this.cards = Object.values(data).map(c => new CardPreview(c))
    }

    async loadPage(page: number, size: number) {
        console.log(page, size, (page - 1) * size, (page - 1) * size + size + 1)
        const cards = this.cards.slice((page - 1) * size, (page - 1) * size + size)
        cards.forEach(c => c.active.loading = true)
        for (const cp of cards) {
            await cp.render()
        }
    }
}
